import { observable, makeObservable } from 'mobx';

import { createModelSchema, primitive, object } from 'serializr';

import { Contact } from '@vromo/models';
import { Coords } from '@vromo/models';
import { Campaign } from '@vromo/models';

import { optional } from '@vromo/models';

import { Policy } from '@vromo/models';
import { Blueprint } from '@vromo/models';

class SiteSource {
    key = '';
    type = 0;

    constructor() {
        makeObservable(this, {
            key: observable,
            type: observable
        });
    }
}

createModelSchema(SiteSource, {
    key: primitive(),
    type: primitive()
});

export class Site {
    id?: number;
    created?: number;

    group?: number;

    contact?: Contact;

    coords?: Coords;
    radius?: number | null;

    source?: SiteSource;

    external?: string | null;

    campaign?: Campaign | null;
    policy?: Policy | null;

    blueprint?: Blueprint;

    constructor(id?: number) {
        makeObservable(this, {
            id: observable,
            group: observable,
            contact: observable,
            coords: observable,
            radius: observable,
            source: observable,
            external: observable,
            campaign: observable,
            policy: observable,
            blueprint: observable,
        });

        if (id) this.id = id;
    }
}

createModelSchema(Site, {
    id: primitive(),
    created: primitive(),
    group: primitive(),

    contact: optional(object(Contact)),
    coords: object(Coords),
    radius: primitive(),
    source: object(SiteSource),

    external: primitive(),

    campaign: object(Campaign),
    policy: object(Policy),

    blueprint: object(Blueprint)
});
